import React from 'react';
import ActionCenterConversationList from '../ActionCenterConversationList/ActionCenterConversationList';
import { ConversationListType } from '../../Enums/ConversationListType.enum';

// @ts-ignore
import styles from './ActionCenterSent.module.scss';

const ActionCenterSent: React.FC = () => {
	return (
		<div className={styles.wrapper}>
			<ActionCenterConversationList type={ConversationListType.SENT} />
		</div>
	);
};

export default ActionCenterSent;
